import { valueOrDefault } from 'Lib/Any';
import { FormatTypes } from 'Lib/Format';
import { pipe } from 'Lib/Hooks/Selectors';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, ButtonGroup, Checkbox, Field, NumericInput, RadioGroup, TextOutput } from '../../../../../Core';
import { withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../../Layout';
import { IWorksheetComponent, WorksheetEquipmentDropdown } from '../../../../Core';
import { WorksheetBalanceFieldSet } from '../../../../Core/WorksheetEquipment';
import { GrainSize } from '../../../types';
let AsPreparationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const [testConditionsEditable, setTestConditionsEditable] = useState(false);

  const grainSizeOptions: Array<{ label: string; value: GrainSize }> = [
    { label: 'Fine', value: GrainSize.Fine },
    { label: 'Medium', value: GrainSize.Medium },
    { label: 'Coarse', value: GrainSize.Coarse },
  ];

  //Grain Size may be hidden for tests with an embedded/measured MC test
  const hideGrainSize = useSelector(pipe(createWorksheetSelector!('Preparation.HideGrainSize'), valueOrDefault(false)));
  return (
    <>
      {testConditionsEditable ? (
        <ListFieldSection>
          <Field input={<NumericInput />} name="Equipment.DryingTemperature" />
          <Field input={<Checkbox />} name="Preparation.ContainsGypsum" />
        </ListFieldSection>
      ) : (
        <>
          <ListFieldSection visible={!testConditionsEditable}>
            <Field input={<TextOutput />} name="Equipment.DryingTemperature" />
            <Field input={<TextOutput />} name="Preparation.ContainsGypsum" format={{ type: FormatTypes.YesNo }} />
          </ListFieldSection>
          <ButtonGroup>
            <Button
              onClick={() => {
                setTestConditionsEditable(true);
              }}
            >
              Change
            </Button>
          </ButtonGroup>
        </>
      )}
      <Field input={<RadioGroup />} name="Preparation.GrainSize" options={grainSizeOptions} visible={!hideGrainSize} />
      <ListFieldSection>
        <WorksheetBalanceFieldSet name="Equipment.Balance" />
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="oven" name="Equipment.Oven" />
      </ListFieldSection>
    </>
  );
};

AsPreparationSection = withInjectedProps(AsPreparationSection);

export { AsPreparationSection };
export default AsPreparationSection;
